export const resolveInternationalPhone = (callingCode, phone) => {
  const rawPhone = String(phone ?? '').trim();
  const codeDigits = String(callingCode ?? '').replace(/\D/g, '');
  const phoneDigits = rawPhone.replace(/\D/g, '');

  if (!phoneDigits) return '';
  if (!codeDigits) return phoneDigits;

  const explicitlyInternational = rawPhone.startsWith('+') || rawPhone.startsWith('00');
  const alreadyCanonical = phoneDigits.length > 10 && phoneDigits.startsWith(codeDigits);
  if (explicitlyInternational || alreadyCanonical) return phoneDigits.replace(/^00/, '');

  return `${codeDigits}${phoneDigits}`;
};

export const resolveNationalPhone = (callingCode, phone, maxNationalLength = 11) => {
  const rawPhone = String(phone ?? '').trim();
  const codeDigits = String(callingCode ?? '').replace(/\D/g, '');
  const phoneDigits = rawPhone.replace(/\D/g, '').replace(/^00/, '');

  if (!phoneDigits || !codeDigits || !phoneDigits.startsWith(codeDigits)) {
    return phoneDigits;
  }

  const explicitlyInternational = rawPhone.startsWith('+') || rawPhone.startsWith('00');
  const includesCountryCode = explicitlyInternational || phoneDigits.length > maxNationalLength;

  return includesCountryCode ? phoneDigits.slice(codeDigits.length) : phoneDigits;
};
